import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Callback from '@/views/auth/Callback.vue'
import Login from '@/views/auth/Login.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/pay-slips',
  },
  {
    path: '/auth/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/auth/callback',
    name: 'OAuth2 callback',
    component: Callback,
  },
  {
    path: '/pay-slips',
    name: 'Pay slips',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/upload',
    name: 'Upload pay slips',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Upload.vue'),
  },
  {
    path: '/employees',
    name: 'Employees',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Employees.vue'),
  },
  {
    path: '/releases',
    name: 'Release pay slips',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Release.vue'),
  },
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
